<script setup lang="ts">
import { logger } from '@pkg/logger';
import { THEME } from '@pkg/config/misc/theme';
import { mapLocaleToTech } from '@pkg/utilities/i18n/localeMapping';
const props = defineProps<{
  theme?: THEME,
}>();

const { locale } = useI18n();
onMounted(() => {
  try {
    if (document.getElementById('CookiePolicy')) { return; }
    const script = document.createElement('script');
    script.id = 'CookiePolicy';
    script.src = 'https://policy.app.cookieinformation.com/cid.js';
    script.type = 'text/javascript';
    script.setAttribute('data-culture', mapLocaleToTech(locale.value));
    script.onload = () => {
      if (window.CookieInformation?.load) {
        logger.info('CookieInformation loaded ✅');
        window.CookieInformation.load();
      } else {
        logger.warn('CookieInformation not found on window ❌');
      }
    };
    const targetElement = document.getElementById('dynamic-cookies-script');
    if (targetElement) {
      targetElement.appendChild(script);
    } else {
      logger.warn('Fallback, append to body');
      document.body.appendChild(script);
    }
  } catch (error) {
    logger.error('Error loading Cookie List', error);
  }
});
</script>

<template>
  <PartialSection :theme="props.theme || THEME.DARK">
    <div class="c-section-block__wrapper wrapper">
      <div id="dynamic-cookies-script" class="c-section-block__content" />
    </div>
  </PartialSection>
</template>
